import PureGameElement from '../../tools/PureGameElement';
import {
    animalWidthProportion,
    railPadding,
    gameWindowSize,
    diffBaseAnimalVelocity,
}                      from '../../constants/appConstants';
import {animalAudio} from '../../constants/audioConstants';

class Animal extends PureGameElement {
    constructor ( scene, currentRail, config ) {
        super( scene );
        this._currentRail = currentRail;
        this._sprite = null;
        this._config = config;
    }

    get posX () {
        return this._currentRail.leftCenterPosition;
    }

    get width () {
        return Math.round( gameWindowSize.width / 100 * animalWidthProportion );
    }

    get height () {
        return this.width;
    }

    get velocity () {
        return this.scene.difficulty * diffBaseAnimalVelocity;
    }

    create () {
        super.create();
        const { spriteId, animId } = this._config;

        this._sprite = this.scene.add.sprite( this.posX, 0, spriteId );
        this._sprite.setSize( this.width, this.height );
        this._sprite.setDisplaySize( this.width, this.height );
        this._sprite.setOrigin( 0.5, 1 );
        this._sprite.depth = 1;
        this._sprite.anims.load( animId );
        this._sprite.anims.play( animId );

        this.scene.physics.world.enable( this._sprite );
        this._sprite.body.width = this._currentRail.width - railPadding;
        this._sprite.body.height = this.height;
        this._sprite.body.setOffset( railPadding / 2, 0 );
        this._sprite.body.setVelocityY( this.velocity );

        this.scene.physics.add.overlap( this._sprite, this.scene.boat.sprite, () => {
            this.scene.sound.play(animalAudio.key); // song add() in SpawnManager
            this.scene.scoreManager.addCollectedAnimal( this._config.id );
            this.destroy();
        } );
    }

    update () {
        super.update();
        if ( this._sprite.y > gameWindowSize.height + this.height ) {
            this.destroy();
        }
    }

    onDifficultyUpdate ( newDifficulty ) {
        this._sprite.body.setVelocity( 0, this.velocity );
    }

    destroy () {
        this.scene.animalsManager.destroyAnimal( this );
        this._sprite.destroy();
    }

}

export default Animal;
